<template lang="html">
  <div class="page-container">
    <div class="article page-container">
      <router-link class="article__back" to="/articles">
        <svg class="pagination__item__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Înapoi
      </router-link>
      <template v-if="articleLoading">
        <div class="article__image skeleton" />
        <h2 class="article__title skeleton" style="height: 40px; width: 100%;" />

        <div class="article__meta">
          <div class="article__meta__author-avatar skeleton" />
          <span class="skeleton" style="height: 15px; width: 100%; max-width: 200px;" />
        </div>

        <p class="article__paragraph skeleton" style="height: 20px; width: 100%; margin-bottom: 15px;" />
        <p class="article__paragraph skeleton" style="height: 20px; width: 100%; margin-bottom: 15px;" />
        <p class="article__paragraph skeleton" style="height: 20px; width: 80%;" />
      </template>
      <template v-else-if="!(article) || !(article.id)">
        Articolul nu a putut fi gasit.
      </template>
      <template v-else>
        <img class="article__image" :src="article.image_url" />

        <h2 class="article__title">
          {{ article.title }}
        </h2>

        <div class="article__meta">
          <img
            class="article__meta__author-avatar"
            :src="article.specialist[0].image_url"
          />
          {{ new Date(article.created_at) | moment("D MMMM YYYY") }} de  <span class="article__author" @click="specialistProfile()"> {{ article.specialist[0].full_name }}</span>
        </div>

        <div class="article__paragraph" v-html="article.content">
        </div>

        <div class="article__divider"></div>

        <div class="article__footer">
          <div class="article__footer__tag">
            <b>Tags:</b> {{ article.tags.map(tag => tag.name).join(', ') }}
          </div>
          <div class="article__footer__social">
            <b>Share:</b>
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${ share }`" target="_blanc">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <!-- Instagram doesn't support sharing links :(
            <a href="#">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            -->
          </div>
        </div>

        <div class="article__comment">
          <h3 class="article__comment__header" v-if="commentsLoading || comments.length === 0">
            Comentarii
          </h3>
          <h3 class="article__comment__header" v-else>
            Comentarii ({{ comments.length }})
          </h3>

          <template v-if="commentsLoading">
            <Comment :skeleton="true" />
            <Comment :skeleton="true" />
            <Comment :skeleton="true" />
          </template>

          <template v-else-if="comments.length === 0">
            Nu sunt comentarii de afisat.
          </template>

          <template v-for="(comment, index) of comments" v-else>
            <Comment :comment="comment" :key="`comment-${ comment.id }`" />
            <div class="article__divider" v-if="index + 1 < comments.length" />
          </template>


          <h3 v-if="comments.length === 0" style="margin-top: 40px">
            Fii primul care scrie un comentariu la această postare
          </h3>
          <h3 v-else style="margin-top: 40px">
            Postează un comentariu drept {{ user ? user.full_name : '(loading)' }}
          </h3>

          <small v-if="commentsWaiting" style="color: #3c59a6; margin-top: 10px">
            Comentariul tău urmează să fie confirmat de către un admin, nu puteți adăuga alt răspuns sau comentariu până atunci.
          </small>

          <div class="article__comment__reply__action" :class="{ 'disabled': commentsWaiting }">
            <input
              class="article__comment__reply__input"
              :disabled="commentsWaiting"
              placeholder="Scrie un comentariu"
              style="margin: 0"
              v-model="addCommentInput"
            />
            <i
              class="fas fa-paper-plane"
              :class="{ 'disabled': commentsWaiting }"
              @click="
                storeComment({
                  content: addCommentInput,
                });
                addCommentInput = ''
              "
            ></i>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Comment                    from './components/Comment';
import config                     from '@/config';

export default {
  components: { Comment },
  mounted() {
    this.onMount();
  },
  data() {
    return {
      addCommentInput: '',
    }
  },
  computed: {
    ...mapGetters({
      article         : 'article/article',
      articleLoading  : 'article/articleLoading',
      comments        : 'article/comments',
      commentsLoading : 'article/commentsLoading',
      commentsWaiting : 'article/commentsWaiting',
      user            : 'user/user',
    }),

    share() {
      return `${ config.HOST }/articles/view/${ this.$route.params.slug }`;
    }
  },
  methods: {
    ...mapActions({
      fetchArticle: 'article/fetchArticle',
      storeComment: 'article/storeComment',
    }),

    onMount() {
      this.fetchArticle(this.$route.params.slug);
    },
    specialistProfile(){
      this.$router.push('/specialists/profile/'+this.article.specialist_id);
    }
  },
  watch: {
    '$route.params.slug'() {
      this.onMount();
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/pages/article';

  .article__comment__reply__action {
    align-items: center;
    border: 1px solid $color-light-gray;
    display: flex;
    margin-top: 20px;

    & > input {
      border: none;
    }

    &.disabled {
      background: #dddfe7;
    }

    & > i {
      color: $color-secondary;
      cursor: pointer;
      display: flex;
      font-size: 20px;
      margin-right: 10px;

      &:hover {
        opacity: 0.8;
      }

      &.disabled:hover {
        cursor: not-allowed;
        opacity: 1;
      }
    }
  }
</style>

<style scoped>
.article__paragraph /deep/ *{
    letter-spacing: 0.3px;
}

.article__paragraph /deep/ strong, b{
  font-weight: 500;
}

.article__paragraph /deep/ p {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  line-height: 1.75;
  font-weight: 300;
}

.article__paragraph /deep/ h1 {
  font-size: 28px;
  display: block;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
  margin-left: 0;
  margin-right: 0;
}

@media only screen and (min-width: 768px) {
    .article__paragraph /deep/ h1 {
        font-size: 32px;
    }
}

@media only screen and (min-width: 1200px) {
    .article__paragraph /deep/ h1 {
        font-size: 40px;
    }
}

.article__paragraph /deep/ h1 > span{
    color: #373737;
}

.article__paragraph /deep/ h2 {
  display: block;
  margin-top: 0.83em;
  margin-bottom: 0.83em;
  margin-left: 0;
  margin-right: 0;
}

.article__paragraph /deep/ h3 {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
}

.article__paragraph /deep/ h4 {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
}

.article__paragraph /deep/ h5 {
  display: block;
  margin-top: 1.67em;
  margin-bottom: 1.67em;
  margin-left: 0;
  margin-right: 0;
}

.article__paragraph /deep/ h6 {
  display: block;
  margin-top: 2.33em;
  margin-bottom: 2.33em;
  margin-left: 0;
  margin-right: 0;
}

.article__paragraph /deep/ ul{
  display: block;
  list-style-type: disc;
  margin-top: 1em;
  margin-bottom: 1 em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 40px;
  line-height: 1.75;
  font-weight: 300;
}

.article__paragraph /deep/ table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  object-fit: contain;
}

.article__paragraph /deep/ th {
  border: 1px solid black;
}

.article__paragraph /deep/ td {
  padding: 5px;
  border: 1px solid black;
}
</style>